import { render } from "./FileFolderProjectPopup.vue?vue&type=template&id=520fecb9&scoped=true"
import script from "./FileFolderProjectPopup.js?vue&type=script&lang=js"
export * from "./FileFolderProjectPopup.js?vue&type=script&lang=js"

import "./FileFolderProjectPopup.vue?vue&type=style&index=0&id=520fecb9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520fecb9"]])

export default __exports__